import { all, call, put, takeLatest } from 'redux-saga/effects';
import { authOperations, authTypes } from '../../store/auth';

import React from 'react';
import { changePassword } from '../../api/authentication';
import { messageOperations } from '../../store/messages';

const { NEW_CHANGE_PASSWORD } = authTypes;

const successMessageNode = (
  <>
    <h3 className="text-center prompt-content-header">
      Successful password reset!
    </h3>
    <p className="text-center">
      You can now use your password to log in to your account
    </p>
  </>
);
const getErrorMessageNode = (error = 'Oops, something went wrong.') => (
  <>
    <h3 className="text-center prompt-content-header">
      Unsuccessful password reset!
    </h3>
    <p className="text-center">{error}</p>
  </>
);

export const performChangePassword = function* performChangePassword({
  payload,
}) {
  const { changePasswordSuccess, loginSuccess } = authOperations;
  const { sendMessage } = messageOperations;

  try {
    const { errors } = yield call(changePassword, payload.fields);
    if (errors) {
      yield put(
        sendMessage({
          displayType: 'prompt',
          type: 'error',
          header: null,
          message: getErrorMessageNode(errors[0]?.message),
          actions: [
            {
              type: 'danger',
              text: 'Try again',
            },
          ],
          actioned: false,
          required: true,
        }),
      );
    } else {
      yield all([
        put(loginSuccess()),
        put(changePasswordSuccess()),
        put(
          sendMessage({
            displayType: 'prompt',
            type: 'success',
            header: null,
            message: successMessageNode,
            actions: [
              {
                type: 'success',
                text: 'Continue',
              },
            ],
            actioned: false,
            required: true,
          }),
        ),
      ]);
    }
  } catch (error) {
    yield put(
      sendMessage({
        displayType: 'prompt',
        type: 'error',
        header: null,
        message: getErrorMessageNode(),
        actions: [
          {
            type: 'danger',
            text: 'Try again',
          },
        ],
        actioned: false,
        required: true,
      }),
    );
  }
};

export default takeLatest(NEW_CHANGE_PASSWORD, performChangePassword);
